import { Button, Form, Select } from 'antd';
import { ProjectOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppTypography from '../typography/Typography';
import { colors } from '../../theme/colors/colors';
import { getCTProjects } from '../../services/testingApi';
import { getSelectedProject, setSelectedProject } from '../../services/authApi';
import Login1 from '../../assets/images/login-1.svg';
import Login2 from '../../assets/images/login-2.svg';

const DEFAULT_PROJECT = 'zinnext';

export default function ProjectSelect() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    Promise.resolve()
      .then(() => getCTProjects({ activeOnly: true }))
      .then((res) => {
        if (!active) return;
        const items = res?.items ?? [];
        setProjects(items);

        // default to the previously chosen project, else "zinnext", else first
        const previous = getSelectedProject();
        const preferred =
          items.find((p) => p.id === previous?.id) ||
          items.find((p) => p.projectname?.toLowerCase() === DEFAULT_PROJECT) ||
          items[0];
        if (preferred) form.setFieldsValue({ project: preferred.id });
      })
      .catch((err) => {
        console.error('Unable to load projects:', err);
        if (active) setError('Unable to load projects. Please try again.');
      });

    return () => {
      active = false;
    };
  }, [form]);

  function handleFinish(values) {
    const selected = projects.find((p) => p.id === values.project);
    if (!selected) {
      setError('Please select a project.');
      return;
    }
    setLoading(true);
    setSelectedProject({ id: selected.id, name: selected.projectname });
    navigate('/addTestCase', { replace: true });
  }

  return (
    <div className="auth-login-page">
      <section className="auth-login-bg" style={{ background: colors.brand }}>
        <div className="auth-login-static-section">
          <div>
            <img src={Login1} alt="" className="auth-login-img-one" />
          </div>
          <div className="auth-login-hero-wrap">
            <img src={Login2} alt="" className="auth-login-img-two" />
          </div>
          <AppTypography
            as="p"
            variant="body"
            color="inverse"
            size="2xl"
            weight="regular"
            align="right"
            className="auth-login-tagline"
          >
            Best in class processes in a box.
          </AppTypography>
        </div>
      </section>

      <section className="auth-login-form-layout">
        <div className="auth-login-form-container">
          <div className="auth-login-form-shell">
            <div className="auth-login-brand">
              <img src="/favicon.ico" alt="" className="auth-login-logo" />
              <AppTypography
                variant="h3"
                color="primary"
                weight="bold"
                className="auth-login-brand-text"
              >
                Zinnext
              </AppTypography>
            </div>

            <div className="auth-login-body">
              <div className="auth-login-sign-body">
                <AppTypography
                  variant="h2"
                  color="primary"
                  weight="bold"
                  align="center"
                  className="auth-login-title"
                >
                  Select Project
                </AppTypography>

                <div className="auth-login-form-con">
                  <Form
                    form={form}
                    className="v1-form auth-login-form"
                    layout="vertical"
                    requiredMark={false}
                    onFinish={handleFinish}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Project"
                      name="project"
                      rules={[{ required: true, message: 'Select a project.' }]}
                    >
                      <Select
                        size="large"
                        showSearch
                        optionFilterProp="label"
                        placeholder="Select project"
                        prefix={<ProjectOutlined />}
                        options={projects.map((p) => ({
                          value: p.id,
                          label: p.projectname,
                        }))}
                      />
                    </Form.Item>

                    {error && (
                      <Form.Item>
                        <AppTypography color="danger" variant="body">
                          {error}
                        </AppTypography>
                      </Form.Item>
                    )}

                    <Button
                      className="auth-login-submit"
                      block
                      size="large"
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      id="znxt-select-project"
                    >
                      Continue
                    </Button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
